// extracted by mini-css-extract-plugin
export default {"spinner":"spinner---WO6Oa","sk-bouncedelay":"sk-bouncedelay---eTSvK","bounce1":"bounce1---v9lTb","bounce2":"bounce2---eHJYg"};